if (!window.__vhStoriesLoaded) {
  window.__vhStoriesLoaded = true;

  const STORY_DURATION_MS = 4000;

  function init(widget) {
    if (!widget || widget.dataset.vhStoriesInit === '1') return;
    widget.dataset.vhStoriesInit = '1';

    const container = widget.querySelector('[data-vh-stories-container]');
    const modal = widget.querySelector('[data-vh-story-modal]');
    const video = widget.querySelector('[data-vh-story-video]');
    const closeBtns = widget.querySelectorAll('[data-vh-story-close]');
    if (!container || !modal || !video) return;

    // Portal modal to <body>: escapes any ancestor stacking context (PDP info
    // column, sticky containers, etc.) that would otherwise trap position:fixed
    // under the header. The modal still works because all listeners below are
    // attached to the modal element itself, not its position in the tree.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    const items = Array.from(container.querySelectorAll('.vh-story'));
    if (!items.length) return;

    let currentIndex = 0;
    let raf = null;
    let isOpen = false;

    items.forEach((item) => {
      const ring = item.querySelector('.vh-story__ring-progress');
      if (!ring) return;
      ring.setAttribute('pathLength', '100');
      ring.style.strokeDasharray = '100';
      ring.style.strokeDashoffset = '100';
    });

    const stopRing = () => {
      if (raf) {
        cancelAnimationFrame(raf);
        raf = null;
      }
    };

    const advanceRing = () => {
      // Auto-advance disabled: mixed video aspect ratios caused visible
      // resize/flicker between stories. User now controls navigation by
      // closing and reopening (or via the native <video controls> UI).
      // Keep function as no-op so existing callers don't break.
    };

    const runRing = (index) => {
      stopRing();
      items.forEach((item, i) => {
        const p = item.querySelector('.vh-story__ring-progress');
        if (!p) return;
        if (i !== index) p.style.strokeDashoffset = '100';
      });

      const progress = items[index] && items[index].querySelector('.vh-story__ring-progress');
      if (!progress) return;

      const start = performance.now();
      const tick = (now) => {
        const fraction = Math.min((now - start) / STORY_DURATION_MS, 1);
        progress.style.strokeDashoffset = String(100 - fraction * 100);
        if (fraction < 1) {
          raf = requestAnimationFrame(tick);
        } else {
          advanceRing();
        }
      };
      raf = requestAnimationFrame(tick);
    };

    const pauseThumbs = () => {
      widget.querySelectorAll('[data-vh-thumb-video]').forEach((v) => {
        try { v.pause(); } catch (e) {}
      });
    };

    const resumeThumbs = () => {
      widget.querySelectorAll('[data-vh-thumb-video]').forEach((v) => {
        const p = v.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      });
    };

    const setupAutoplayThumbs = () => {
      const thumbs = widget.querySelectorAll('[data-vh-thumb-video]');
      if (!thumbs.length) return;

      if (!('IntersectionObserver' in window)) {
        resumeThumbs();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const thumb = entry.target;
            if (entry.isIntersecting && !isOpen) {
              const play = thumb.play();
              if (play && typeof play.catch === 'function') play.catch(() => {});
            } else {
              try { thumb.pause(); } catch (e) {}
            }
          });
        },
        { rootMargin: '120px', threshold: 0.1 }
      );

      thumbs.forEach((thumb) => observer.observe(thumb));
    };

    const openModal = (item, index) => {
      const url = item.getAttribute('data-vh-video-url');
      if (!url) return;
      video.src = url;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      isOpen = true;
      currentIndex = index;
      video.muted = false;
      video.play().catch(() => {
        video.muted = true;
        video.play().catch(() => {});
      });
      pauseThumbs();
      runRing(index);
      document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      try { video.pause(); } catch (e) {}
      video.src = '';
      isOpen = false;
      stopRing();
      resumeThumbs();
      document.body.style.overflow = '';
    };

    items.forEach((item, i) => {
      item.addEventListener('click', () => openModal(item, i));
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openModal(item, i);
        }
      });
    });

    closeBtns.forEach((b) => b.addEventListener('click', closeModal));
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', (e) => { if (isOpen && e.key === 'Escape') closeModal(); });

    setupAutoplayThumbs();
  }

  const initAll = () => {
    document.querySelectorAll('[data-vh-stories]').forEach(init);
  };

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-vh-stories]').forEach(init);
  });
}
